import type { Control, FieldValues, Path } from "react-hook-form";
import { FormCheckboxField } from "@/components/base/form/form-checkbox-field";
import { FormField } from "@/components/base/form/hook-form";
import { ReferenceRequirementsField } from "./reference-requirements-field";

export interface ProofOfWorkFieldNames {
	requireImage: string;
	requireDescription: string;
	requireReferenceId: string;
	referenceRequirements: string;
}

export interface ProofOfWorkSectionProps<T extends FieldValues> {
	control: Control<T>;
	fieldNames: ProofOfWorkFieldNames;
	requireProofOfWork: boolean;
	requireReferenceId: boolean;
	onToggle?: () => void;
}

export const ProofOfWorkSection = <T extends FieldValues>({
	control,
	fieldNames,
	requireProofOfWork,
	requireReferenceId,
	onToggle,
}: ProofOfWorkSectionProps<T>) => {
	return (
		<div className="ml-4 flex flex-col gap-2">
			<FormField
				control={control}
				name={fieldNames.requireReferenceId as Path<T>}
				render={({ field }) => (
					<FormCheckboxField
						field={field}
						label="Require Reference IDs"
						inputClasses="w-fit"
						isDisabled={!requireProofOfWork}
						onChange={() => onToggle?.()}
					/>
				)}
			/>
			{requireReferenceId && requireProofOfWork && (
				<div className="ml-8">
					<ReferenceRequirementsField control={control} name={fieldNames.referenceRequirements} />
				</div>
			)}
			<FormField
				control={control}
				name={fieldNames.requireImage as Path<T>}
				render={({ field }) => (
					<FormCheckboxField
						field={field}
						label="Image"
						inputClasses="w-fit"
						isDisabled={!requireProofOfWork}
					/>
				)}
			/>
			<FormField
				control={control}
				name={fieldNames.requireDescription as Path<T>}
				render={({ field }) => (
					<FormCheckboxField
						field={field}
						label="Description of work completed"
						inputClasses="w-fit"
						isDisabled={!requireProofOfWork}
					/>
				)}
			/>
		</div>
	);
};